import React from 'react';
import clsx from 'clsx';
import type { SpacingValue } from '../types/spacing';

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Apply spacing to all sides
   */
  space?: SpacingValue;
  
  /**
   * Apply spacing to top
   */
  top?: SpacingValue;
  
  /**
   * Apply spacing to right
   */
  right?: SpacingValue;
  
  /**
   * Apply spacing to bottom
   */
  bottom?: SpacingValue;
  
  /**
   * Apply spacing to left
   */
  left?: SpacingValue;
  
  /**
   * Apply horizontal spacing (left and right)
   */
  horizontal?: SpacingValue;
  
  /**
   * Apply vertical spacing (top and bottom)
   */
  vertical?: SpacingValue;
  
  /**
   * The content of the box
   */
  children: React.ReactNode;
}

/**
 * Box component for layout with conditional spacing props
 */
export const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  (
    {
      space,
      top,
      right,
      bottom,
      left,
      horizontal,
      vertical,
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'prometheus-box',
          {
            // All sides spacing
            [`prometheus-box--space-${space}`]: space,
            
            // Individual sides
            [`prometheus-box--top-${top}`]: top,
            [`prometheus-box--right-${right}`]: right,
            [`prometheus-box--bottom-${bottom}`]: bottom,
            [`prometheus-box--left-${left}`]: left,
            
            // Horizontal and vertical
            [`prometheus-box--horizontal-${horizontal}`]: horizontal,
            [`prometheus-box--vertical-${vertical}`]: vertical,
          },
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Box.displayName = 'Box';

export default Box;